// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"626":"82dcb76c","970":"b8df387a"}[chunkId] + ".chunk.js";
};